import { createAction, props } from "@ngrx/store";
import { IIndustryItem } from "@skills-app/models/industry";

const prefix = "[Industry Search Bar]";

export const loadComponent = createAction(`${prefix} Load Component`);
export const unloadComponent = createAction(`${prefix} Unload Component`);
export const addIndustryItemToSearch = createAction(
  `${prefix} Add Industry Item To Search`,
  props<{ industryItem: IIndustryItem }>(),
);
export const removeIndustryItemFromSearch = createAction(
  `${prefix} Remove Industry Item From Search`,
  props<{ industryItem: IIndustryItem }>(),
);
export const changeIndustryComboLogic = createAction(
  `${prefix} Change Industry Combo Logic`,
);
export const resetIndustryComboLogic = createAction(
  `${prefix} Reset Industry Combo Logic`,
);
